export const TwoUsers = ({ color = "currentColor" }) => (
  <svg width="1em" height="1em" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.0209 10.9837C14.6328 9.89887 17.8779 11.2748 18.8834 15.1114C19.1285 16.0464 18.3451 16.875 17.3785 16.875H13.5417M8.95833 5.83333C8.95833 7.3291 7.74577 8.54167 6.25 8.54167C4.75423 8.54167 3.54167 7.3291 3.54167 5.83333C3.54167 4.33756 4.75423 3.125 6.25 3.125C7.74577 3.125 8.95833 4.33756 8.95833 5.83333ZM16.4583 5.83333C16.4583 7.3291 15.2458 8.54167 13.75 8.54167C12.2542 8.54167 11.0417 7.3291 11.0417 5.83333C11.0417 4.33756 12.2542 3.125 13.75 3.125C15.2458 3.125 16.4583 4.33756 16.4583 5.83333ZM9.75933 16.875H2.62162C1.655 16.875 0.872184 16.0421 1.11773 15.1072C2.68734 9.13094 9.69361 9.13094 11.2632 15.1072C11.5088 16.0421 10.726 16.875 9.75933 16.875Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default TwoUsers
